// removed by extract-text-webpack-plugin
module.exports = {"videoContainer":"sOyPijeip2ZKXxBcI84RN","marquee":"_1aL6UOdY2zlC1gN7Ztfd2a","slider":"_3I7sj3BZVE78GuQsVChp6E","sliderContent":"vDMSuKkWUlByjXE51LIgu","sliderRacer":"_3kFZJj2PHiCWhdxffbyENL","sliderText":"gvVli2cJCh1rFuvTOomLM","iframe":"_2DU1zv3TerjuToFZsGRiAW","racerIconContainer":"_2TN7_aWdjsvOfJARpxTpqz","racerNumber":"kJweJIg0565KtgKzAP8Tj","racerIcon":"_1xSQVHKnzurmAakOEbWb7S"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/mobile/css/videoPlayer.css
// module id = 1017
// module chunks = 0